import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Suppress benign ResizeObserver loop errors triggered by MUI/react-select layout reflows
window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        e.stopImmediatePropagation();
    }
});

// React 18 root API: enables automatic batching of state updates in async continuations
// (after await/.then/setTimeout), which legacy ReactDOM.render did not do.
const root = createRoot(document.getElementById('root')!);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
          // event.target is this same ServiceWorker; DOM lib types it generically
          // as EventTarget, so it's narrowed here to read .state.
          if ((event.target as ServiceWorker).state === "activated") {
              let evt = document.createEvent('Event');
              evt.initEvent('react_spa_update', true, true);
              window.dispatchEvent(evt);
            }
        });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
 },
 onFailure: () => {
     let evt = document.createEvent('Event');
     evt.initEvent('react_spa_noconnection', true, true);
     window.dispatchEvent(evt);
 }
});
